import { SeverityIcon } from '@/ui/components/svg/SeverityIcon'
import React from 'react'
import { FilterModuleConfig, transformToGenericFilterConfig } from '../filters'
import { UnifiedFilterConfig } from '../filters/unified-filter.module'

import { SearchKeyConfig } from '@core/modules/filters/unified-filter.module'

export const fraudDefenseSearchKeys: SearchKeyConfig[] = [
    { value: 'severity', threshold: 0.2 },
    { value: 'email_data.subject', threshold: 0.4 },
    { value: 'sender.emailAddress', threshold: 0.3 },
    { value: 'sender.name', threshold: 0.3 },
    { value: 'recipients.emailAddress', threshold: 0.3 },
]

const config = {
    severity: {
        accessor: 'severity',
        label: 'Severity',
        collapsible: true,
        filters: {
            critical: {
                accessor: 'critical',
                label: 'Critical',
                icon: React.createElement(SeverityIcon, {
                    severity: 'critical',
                }),
            },
            important: {
                accessor: 'important',
                label: 'Important',
                icon: React.createElement(SeverityIcon, {
                    severity: 'important',
                }),
            },
            moderate: {
                accessor: 'moderate',
                label: 'Moderate',
                icon: React.createElement(SeverityIcon, {
                    severity: 'moderate',
                }),
            },
        },
    },
    status: {
        accessor: 'status',
        label: 'Status',
        collapsible: true,
        filters: {
            open: {
                accessor: 'open',
                label: 'Open',
            },
            resolved: {
                accessor: 'resolved',
                label: 'Resolved',
            },
        },
    },
    recipients: {
        accessor: 'recipients',
        label: 'Recipients',
        collapsible: true,
        withSearch: true,
        filters: {
            // Dynamic filters populated at runtime via module state
        },
    },
}

const defaultFilters = {
    severity: {
        critical: false,
        important: false,
        moderate: false,
    },
    status: {
        open: true,
        resolved: false,
    },
    recipients: {}, // Re-enabled for dynamic filters
}

export const fraudDefenseFilterConfig: FilterModuleConfig =
    transformToGenericFilterConfig(
        { fraudDefense: config },
        { fraudDefense: defaultFilters }
    ).fraudDefense

export { config, defaultFilters }

export const unifiedFraudDefenseConfig: UnifiedFilterConfig = {
    ...fraudDefenseFilterConfig,
    searchKeys: fraudDefenseSearchKeys,
    sortStrategy: (a: TFraudDefenseIssue, b: TFraudDefenseIssue) => {
        const severityOrder: Record<string, number> = {
            critical: 4,
            important: 3,
            moderate: 2,
            clean: 1,
        }

        const severityComparison =
            (severityOrder[b.severity] || 0) - (severityOrder[a.severity] || 0)
        if (severityComparison !== 0) return severityComparison

        const aTime = new Date(a.email_data?.date_sent || 0).getTime()
        const bTime = new Date(b.email_data?.date_sent || 0).getTime()
        return bTime - aTime
    },
    dataTransformer: (data: TFraudDefenseIssue[]) => {
        return data.map((issue) => ({
            ...issue,
            recipients: issue?.recipients?.map((r: any) => ({
                ...r,
                _filterString: r.emailAddress || r.name || '',
            })),
        }))
    },
    dynamicFilters: {
        recipients: {
            accessor: 'recipients',
            label: 'Recipients',
            collapsible: true,
            withSearch: true,
            extractor: (data: any[]) => {
                const uniqueValues = new Set<string>()
                data.forEach((issue) => {
                    if (issue.recipients) {
                        issue.recipients.forEach((recipient: any) => {
                            const recipientKey =
                                recipient.emailAddress ||
                                recipient.name ||
                                recipient._filterString
                            if (recipientKey) {
                                uniqueValues.add(recipientKey)
                            }
                        })
                    }
                })
                return Array.from(uniqueValues)
            },
        },
    },
}
